class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new window.PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1.75,
      maxZoomLevel: 3,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      preload: [1, 6],

      closeOnVerticalDrag: true,

      tapAction: 'zoom',

      pswpModule: () => {
        return window.PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
    })

    this.photoSwipeInstance.on('change', () => {
      this.handleSlideChange()
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = event => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  handleSlideChange () {
    const { pswp } = this.photoSwipeInstance
    const previousEl = window.BAO.Utils.getElement(
      '.pswp-Action_Arrow-previous',
    )
    const nextEl = window.BAO.Utils.getElement('.pswp-Action_Arrow-next')

    if (pswp && previousEl) {
      previousEl.disabled = pswp.currIndex === 0
    }

    if (pswp && nextEl) {
      nextEl.disabled = pswp.currIndex + 1 === pswp.getNumItems()
    }
  }

  get arrowSvg () {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="m3.854 1.555 3.182 3.182a.5.5 0 0 1 0 .707L3.854 8.626a.5.5 0 1 1-.708-.707l2.536-2.536v-.586L3.146 2.262a.5.5 0 1 1 .708-.707Z"/></svg>'
  }

  get closeSvg () {
    return `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.767 15.5172L15.6594 14.6249L8.9446 7.91013L15.5695 1.28523L14.7199 0.435602L8.09497 7.0605L1.51723 0.482765L0.624901 1.3751L7.20264 7.95284L0.577737 14.5777L1.42736 15.4274L8.05226 8.80246L14.767 15.5172Z"/></svg>`
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
